import axios from "axios";
import Globais, { validateToken } from "../components/Globais";
import { DiagnosticoOperacionalIrregularidade } from "../interfaces/DiagnosticoOperacionalIrregularidade";

export const buscarDiagnosticoOperacionalIrregularidadesService = async () => {
  const token = validateToken();

  if (!token) {
    return null;
  }

  const url = `${Globais.DOMINIOBACK}/cota-usuario/diagnostico/irregularidades`;

  try {
    const response = await axios.get<DiagnosticoOperacionalIrregularidade[]>(
      url,
      {
        headers: { Authorization: token.AuthStr },
      }
    );

    return response.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};
